var v = "5.8.1";
var fr = 29.9700012207031;
var ip = 0;
var op = 65.0000026475043;
var w = 468;
var h = 468;
var nm = "Link";
var ddd = 0;
var assets = [];
var layers = [
    {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Isolation Mode 3",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    209.536,
                    258.333,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        -11.453,
                                        11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        -11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.453,
                                        -11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                o: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        -11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.453,
                                        -11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.453,
                                        11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        11.453
                                    ]
                                ],
                                v: [
                                    [
                                        5.958,
                                        35.761
                                    ],
                                    [
                                        35.761,
                                        5.958
                                    ],
                                    [
                                        35.761,
                                        -35.518
                                    ],
                                    [
                                        35.518,
                                        -35.761
                                    ],
                                    [
                                        -5.958,
                                        -35.761
                                    ],
                                    [
                                        -35.761,
                                        -5.958
                                    ],
                                    [
                                        -35.761,
                                        35.518
                                    ],
                                    [
                                        -35.518,
                                        35.761
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.787,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 0,
                    k: 21,
                    ix: 1
                },
                e: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.134
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.844
                                ],
                                y: [
                                    0.002
                                ]
                            },
                            t: 2,
                            s: [
                                21
                            ]
                        },
                        {
                            t: 43.0000017514259,
                            s: [
                                97
                            ]
                        }
                    ],
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 40,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 1
    },
    {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Isolation Mode 2",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    258.464,
                    209.405,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    0,
                    0,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ind: 0,
                        ty: "sh",
                        ix: 1,
                        ks: {
                            a: 0,
                            k: {
                                i: [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.453,
                                        11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.453,
                                        -11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        -11.453
                                    ]
                                ],
                                o: [
                                    [
                                        -11.453,
                                        11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        -11.453,
                                        -11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        -11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        11.453,
                                        11.453
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                v: [
                                    [
                                        5.958,
                                        35.761
                                    ],
                                    [
                                        -35.518,
                                        35.761
                                    ],
                                    [
                                        -35.761,
                                        35.518
                                    ],
                                    [
                                        -35.761,
                                        -5.958
                                    ],
                                    [
                                        -5.958,
                                        -35.761
                                    ],
                                    [
                                        35.518,
                                        -35.761
                                    ],
                                    [
                                        35.761,
                                        -35.518
                                    ],
                                    [
                                        35.761,
                                        5.958
                                    ]
                                ],
                                c: true
                            },
                            ix: 2
                        },
                        nm: "Path 1",
                        mn: "ADBE Vector Shape - Group",
                        hd: false
                    },
                    {
                        ty: "st",
                        c: {
                            a: 0,
                            k: [
                                0.101960784314,
                                0.639215686275,
                                1,
                                1
                            ],
                            ix: 3
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 4
                        },
                        w: {
                            a: 0,
                            k: 19.787,
                            ix: 5
                        },
                        lc: 2,
                        lj: 1,
                        ml: 10,
                        bm: 0,
                        nm: "Stroke 1",
                        mn: "ADBE Vector Graphic - Stroke",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "Group 1",
                np: 2,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            },
            {
                ty: "tm",
                s: {
                    a: 1,
                    k: [
                        {
                            i: {
                                x: [
                                    0.134
                                ],
                                y: [
                                    1
                                ]
                            },
                            o: {
                                x: [
                                    0.844
                                ],
                                y: [
                                    -2e-3
                                ]
                            },
                            t: 2,
                            s: [
                                100
                            ]
                        },
                        {
                            t: 43.0000017514259,
                            s: [
                                26
                            ]
                        }
                    ],
                    ix: 1
                },
                e: {
                    a: 0,
                    k: 100,
                    ix: 2
                },
                o: {
                    a: 0,
                    k: 60,
                    ix: 3
                },
                m: 1,
                ix: 2,
                nm: "Trim Paths 1",
                mn: "ADBE Vector Filter - Trim",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 1
    },
    {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Isolation Mode",
        sr: 1,
        ks: {
            o: {
                a: 0,
                k: 100,
                ix: 11
            },
            r: {
                a: 0,
                k: 0,
                ix: 10
            },
            p: {
                a: 0,
                k: [
                    233,
                    233,
                    0
                ],
                ix: 2,
                l: 2
            },
            a: {
                a: 0,
                k: [
                    500,
                    500,
                    0
                ],
                ix: 1,
                l: 2
            },
            s: {
                a: 0,
                k: [
                    100,
                    100,
                    100
                ],
                ix: 6,
                l: 2
            }
        },
        ao: 0,
        shapes: [
            {
                ty: "gr",
                it: [
                    {
                        ty: "gr",
                        it: [
                            {
                                d: 1,
                                ty: "el",
                                s: {
                                    a: 0,
                                    k: [
                                        460,
                                        460
                                    ],
                                    ix: 2
                                },
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 3
                                },
                                nm: "Ellipse Path 1",
                                mn: "ADBE Vector Shape - Ellipse",
                                hd: false
                            },
                            {
                                ty: "fl",
                                c: {
                                    a: 0,
                                    k: [
                                        0.945098039216,
                                        0.972549019608,
                                        1,
                                        1
                                    ],
                                    ix: 4
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 5
                                },
                                r: 1,
                                bm: 0,
                                nm: "Fill 1",
                                mn: "ADBE Vector Graphic - Fill",
                                hd: false
                            },
                            {
                                ty: "tr",
                                p: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 2
                                },
                                a: {
                                    a: 0,
                                    k: [
                                        0,
                                        0
                                    ],
                                    ix: 1
                                },
                                s: {
                                    a: 0,
                                    k: [
                                        100,
                                        100
                                    ],
                                    ix: 3
                                },
                                r: {
                                    a: 0,
                                    k: 0,
                                    ix: 6
                                },
                                o: {
                                    a: 0,
                                    k: 100,
                                    ix: 7
                                },
                                sk: {
                                    a: 0,
                                    k: 0,
                                    ix: 4
                                },
                                sa: {
                                    a: 0,
                                    k: 0,
                                    ix: 5
                                },
                                nm: "Transform"
                            }
                        ],
                        nm: "Oval",
                        np: 2,
                        cix: 2,
                        bm: 0,
                        ix: 1,
                        mn: "ADBE Vector Group",
                        hd: false
                    },
                    {
                        ty: "tr",
                        p: {
                            a: 0,
                            k: [
                                500,
                                500
                            ],
                            ix: 2
                        },
                        a: {
                            a: 0,
                            k: [
                                0,
                                0
                            ],
                            ix: 1
                        },
                        s: {
                            a: 0,
                            k: [
                                100,
                                100
                            ],
                            ix: 3
                        },
                        r: {
                            a: 0,
                            k: 0,
                            ix: 6
                        },
                        o: {
                            a: 0,
                            k: 100,
                            ix: 7
                        },
                        sk: {
                            a: 0,
                            k: 0,
                            ix: 4
                        },
                        sa: {
                            a: 0,
                            k: 0,
                            ix: 5
                        },
                        nm: "Transform"
                    }
                ],
                nm: "icon/2tone/chain",
                np: 1,
                cix: 2,
                bm: 0,
                ix: 1,
                mn: "ADBE Vector Group",
                hd: false
            }
        ],
        ip: 0,
        op: 900.000036657751,
        st: 0,
        bm: 0
    }
];
var markers = [];
var Link = {
    v: v,
    fr: fr,
    ip: ip,
    op: op,
    w: w,
    h: h,
    nm: nm,
    ddd: ddd,
    assets: assets,
    layers: layers,
    markers: markers
};

export { assets, ddd, Link as default, fr, h, ip, layers, markers, nm, op, v, w };
//# sourceMappingURL=Link.json.es.js.map
